import {memo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import CustomBadge from '../../../../../components/mazraeKit/customBadge';
import {RootState} from '../../../../../store/redux';
import {addOptionalRegisterStoreFormData} from '../../../../../store/redux/registerStore';

const LabAdditionalInfo = () => {
  const dispatch = useDispatch();

  const {optionalRegisterFormData} = useSelector(
    (state: RootState) => state.registerStore,
  );

  const sampleFunc = (str: string) => {
    const myobject = str ? JSON.parse(str) : {};

    const keysarr = Object.keys(myobject);

    const selectedItems = keysarr.map(item => {
      const typeofmyobj = typeof myobject[item];

      if (typeofmyobj === 'string') {
        if (myobject[item].indexOf(',') > -1) {
          const newarr = myobject[item].split(',');

          return newarr.map((newarritem: string) => {
            return {title: newarritem, value: item};
          });
        } else {
          return {title: myobject[item], value: item};
        }
      }
      if (typeofmyobj === 'number') {
        return {title: myobject[item], value: item};
      }

      const value = myobject?.[item];

      if (value && typeof value === 'object' && 'title' in value) {
        return {title: value?.title, value: item};
      }
    });

    return selectedItems;
  };

  const closeHandler = (deleteItem: {title: string; value: string}) => {
    const myobjectins = optionalRegisterFormData
      ? {...JSON.parse(optionalRegisterFormData)}
      : {};

    if (typeof myobjectins[deleteItem.value] === 'string') {
      if (myobjectins[deleteItem.value].indexOf(',') > -1) {
        const newArr = myobjectins[deleteItem.value].split(',');

        myobjectins[deleteItem.value] = newArr
          .filter((item: string) => item !== deleteItem.title)
          .toString();
      } else {
        delete myobjectins[deleteItem.value];
      }
    } else {
      delete myobjectins[deleteItem.value];
    }

    dispatch(addOptionalRegisterStoreFormData(JSON.stringify(myobjectins)));
  };

  const titleConvertor = (
    value: string,
    item: {title: string | number; value: string},
  ): string => {
    const titleMap: Record<string, string> = {
      from_hour: ` شروع ساعت کاری از ${item.title}`,
      to_hour: ` پایان ساعت کاری تا ${item.title}`,
      speciality: `تخصص در ${item.title}`,
      result_to_day: `ارائه نتیجه ${item.title} روز کاری`,
    };
    return titleMap[value];
  };

  return (
    <div className="flex flex-wrap gap-2 mt-3 w-100">
      {optionalRegisterFormData &&
        sampleFunc(optionalRegisterFormData)
          .flat(2)
          .filter(item => item?.title)
          .map((item, index) => {
            return (
              <div className="flex gap-1" key={index}>
                <CustomBadge
                  //@ts-ignore
                  title={titleConvertor(item.value, item)}
                  onRemoveItem={() => closeHandler(item)}
                />
              </div>
            );
          })}
    </div>
  );
};

export default memo(LabAdditionalInfo);
